<template>
  <b-container>
    <b-card v-for="(item, index) in items" :key="index" class="mb-3">
      <p>
        {{ item.transactionDate | date }}
      </p>

      <b-row class="mb-2">
        <b-col class="d-flex align-items-center" md="5">
          <p class="price">
            {{ item.transactionValue | value }}
          </p>
        </b-col>

        <b-col md="5">
          <div class="d-flex flex-column">
            <b-img class="ml-3" width="50" :src="getBrandSrc(item.brandDescription)" />

            <p v-if="item.brandDescription === 'MASTERCARD'" class="ml-2">
              {{ item.brandDescription }}
            </p>
          </div>
        </b-col>

        <b-col md="2" />
      </b-row>

      <b-row>
        <b-col md="5">
          <h6> Status: </h6>
          <p> {{ item.status }} </p>
        </b-col>
        <b-col md="5">
          <h6> Titular do Cartão: </h6>
          <p> {{ item.cardHolderName || '-----' }} </p>
        </b-col>
        <b-col md="2">
          <h6> Valor da Transação: </h6>
          <p> {{ item.transactionValue | value }} </p>
        </b-col>
        <b-col md="5">
          <h6> Data da Solicitação: </h6>
          <p> {{ item.incomingDate | date }} </p>
        </b-col>
        <b-col md="5">
          <h6> Data da Transação: </h6>
          <p> {{ item.transactionDate | date }} </p>
        </b-col>
        <b-col md="2">
          <h6> Número do Processo: </h6>
          <p> {{ item.processNumber }} </p>
        </b-col>
        <b-col md="5">
          <h6> Método de Pagamento: </h6>
          <p> {{ item.paymentMethodDescription }} </p>
        </b-col>
        <b-col md="5">
          <h6> Razão: </h6>
          <p> {{ item.chargebackReason }} </p>
        </b-col>
        <b-col md="2">
          <h6> Fraude: </h6>
          <p> {{ item.isFraud ? 'Sim' : 'Não' }} </p>
        </b-col>
        <b-col md="5">
          <h6> Status do Último Documento: </h6>
          <p> {{ item.lastDocumentStatus || '-----' }} </p>
        </b-col>
        <b-col md="5">
          <h6> Quantidade de parcelas: </h6>
          <p> {{ item.installmentQuantity }} </p>
        </b-col>
        <b-col md="2">
          <h6> Parcela de número: </h6>
          <p> {{ item.installmentNumber }} </p>
        </b-col>
        <b-col md="5">
          <h6> Solicitação de Evidência: </h6>
          <p> {{ item.evidenceRequest || '-----' }} </p>
        </b-col>
        <b-col md="5">
          <h6> NSU: </h6>
          <p> {{ item.nsu }} </p>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-button
            style="width: 100%"
            variant="primary"
            @click="$bvModal.show('chargeback-modal')"
          >
            Download
          </b-button>
        </b-col>

        <b-col md="3">
          <b-button
            style="width: 100%"
            variant="primary"
            @click="$bvModal.show('chargeback-upload')"
          >
            Upload
          </b-button>
        </b-col>
      </b-row>

      <b-modal
        id="chargeback-modal"
        hide-footer
        size="lg"
      >
        <b-list-group>
          <b-list-group-item
            v-for="(file, index) in availableFiles"
            :key="index"
            @click="downloadFile(file.fileName)"
          >
            <b-row>
              <b-col md="9">
                {{ file.fileName }}
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-modal>

      <b-modal
        id="chargeback-upload"
        hide-footer
        size="lg"
      >
        <b-form>
          <b-form-group>
            <b-form-file v-model="file" />
          </b-form-group>
        </b-form>

        <b-button @click="uploadFile(file)">
          Enviar
        </b-button>
      </b-modal>
    </b-card>
  </b-container>
</template>

<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ChargebackService from '@/service/chargeback';
import { BButton, BCard, BCol, BContainer, BForm, BFormFile, BFormGroup, BImg, BListGroup, BListGroupItem, BModal, BRow } from 'bootstrap-vue';

export default {

  components: {
        BModal,
        BContainer,
        BCard,
        BRow,
        BCol,
        BImg,
        BButton,
        BListGroup,
        BListGroupItem,
        FeatherIcon,
        BForm,
        BFormGroup,
        BFormFile,
        BModal
    },

  data() {
    return {
      id: this.$route.params.id,
      nsu: this.$route.params.nsu,
      transactionDate: this.$route.params.date,
      items: [],
    };
  },

  async created() {
    this.callLoading(true);
    await this.getHistory();
    this.callLoading(false);
  },

  methods: {
    async getHistory() {
      const { data } = await ChargebackService.history({ nsu: this.nsu, date: this.transactionDate });
      console.log(data);
      
      this.items = data;
    },

    getBrandSrc(brandDescription) {
      const paymentSchemesToImg = {
        'AMERICAN EXPRESS': 'amex.svg',
        MASTERCARD: 'mastercard.svg',
        VISA: 'visa.svg',
        ELO: 'elo.svg',
        HIPERCARD: 'hipercard.svg',
      };
      return require(`@/assets/images/brands/${paymentSchemesToImg[brandDescription] || 'default.svg'}`);
    },
  },
};
</script>

<style lang="scss">
.price {
  font-size: 2rem;
  color: #000;
}

.dark-layout .price {
  color: #fff;
}
</style>
